<template>
  <payment-flow-animation
    :result="result"
    flow="card"
    :overlay="false"
    :success-action-label="actionLabel"
    :error-action-label="actionLabel"
    @action="goCards"
  />
</template>

<script>
import PaymentFlowAnimation from "@/components/payment/PaymentFlowAnimation";

export default {
  name: "CardSuccess",
  components: {
    PaymentFlowAnimation,
  },
  computed: {
    successMessage() {
      return (
        this.$store.state.Payment.cardSaveResultMessage ||
        this.$t("pay.cardAdded")
      );
    },
    result() {
      return {
        success: true,
        alreadyAdded: this.successMessage === this.$t("pay.cardAlreadyAdded"),
        message: this.successMessage,
      };
    },
    actionLabel() {
      if (this.$i18n && this.$i18n.locale === "en") return "To cards";
      if (this.$i18n && this.$i18n.locale === "ru") return "К картам";
      return "До карток";
    },
  },
  methods: {
    async goCards() {
      await this.$router.push({ name: "PaymentCards" });
    },
  },
};
</script>
